// extracted by mini-css-extract-plugin
module.exports = {"labelSection":"MoreDetailsSidebar_labelSection__2sQSg"};